import React, { FC } from 'react';
import styled from 'styled-components';
import { theme, toRem } from 'design';
import { IEmployee, IEmployerSite, ISiteIntegration } from 'types';
import EmployeeListItem from './EmployeeListItem';

const Layout = styled.div`
  width: 100%;
  margin-top: ${toRem(theme.space.lg)};
  border: 1px solid ${theme.color.neutral[300]};
  border-radius: ${toRem(theme.borderRadius.small)};
  overflow: hidden;
`;

const List = styled.ul`
  width: 100%;
  max-height: ${toRem(270)};
  overflow-y: auto;
`;

interface IEmployeeListProps {
  dataCy: string;
  employees: IEmployee[];
  selectedEmployee?: IEmployee;
  site: IEmployerSite;
  integration: ISiteIntegration;
  onSelect(employee: IEmployee): void;
}

const EmployeeList: FC<IEmployeeListProps> = ({ employees, integration, selectedEmployee, site, onSelect, dataCy }) => (
  <Layout>
    <List data-cy={`${dataCy}-employee-list`}>
      {employees.map((employee) => {
        const isLinked = employee.integrations.find((empIntegration) => empIntegration.siteId === site?.id && empIntegration.type.trim().toLowerCase() === integration.type.trim().toLowerCase());
        return <EmployeeListItem key={`employee_${employee.id}`} employee={employee} site={site} isSelected={selectedEmployee && selectedEmployee?.id === employee.id} isLinked={!!isLinked} onSelect={onSelect} dataCy={dataCy} />;
      })}
    </List>
  </Layout>
);

export default EmployeeList;
